export const DICTIONARY = {
    single: [
        "Cioccolato",
        "Cappio",
        "Ginocchio",
        "Lavabo",
        "Grasso",
        "Mela",
        "Uva",
        "Spaghetti",
        "Zero",
        "Aquila",
        "Tigre",
        "Vecchio",
        "Ripostiglio",
        "Elefante",
        "Freddo",
        "Famiglia",
        "Stanza",
        "Motocicletta",
        "Quattro",
        "Sorella",
        "Carta",
        "Barca",
        "Lucertola",
        "Kiwi",
        "Luna",
        "Sfera",
        "Fiume",
        "Squalo",
        "Tartaruga",
        "Rana",
        "Bocca",
        "Lattuga",
        "Forchetta",
        "Anguria",
        "Chitarra",
        "Calzino",
        "Scuola",
        "Gancio",
        "Silenzio",
        "Palla",
        "Carota",
        "Studente",
        "Capra",
        "Giraffa",
        "Gonna",
        "Razzo",
        "Cavallo",
        "Collo",
        "Bicchiere",
        "Bicicletta",
        "Soffitto",
        "Pomodoro",
        "Sedia",
        "Bidone",
        "Anatra",
        "Sacco",
        "Pancia",
        "Marciapiede",
        "Telefono",
        "Sottile",
        "Madre",
        "Gufo",
        "Autobus",
        "Camion",
        "Primavera",
        "Ottima",
        "Terreno",
        "Parasole",
        "Rubinetto",
        "Margherita",
        "Polpo",
        "Mappa",
        "Girasole",
        "Banana",
        "Palloncini",
        "Gatto",
        "Caramella",
        "Diapositiva",
        "Stella",
        "Cucina",
        "Calze",
        "Capo",
        "Cometa",
        "Veloce",
        "Nuvola",
        "Cibo",
        "Asino",
        "Pesce",
        "Poltrona",
        "Blu",
        "Lupo",
        "Marrone",
        "Mano",
        "Farfalla",
        "Pescatore",
        "Delfino",
        "Formaggio",
        "Orecchie",
        "Yogurt",
        "Ghiaccio",
        "Medico",
        "Strada",
        "Fogliame",
        "Rifugio",
        "Campana",
        "Coccodrillo",
        "Pelle",
        "Soldato",
        "Animale",
        "Passeggiata",
        "Casco",
        "Ciliegie",
        "Montagna",
        "Gamba",
        "Pane",
        "Portafoglio",
        "Lavatrice",
        "Pantaloni",
        "Uno",
        "Granchio",
        "Mangiare",
        "Tazza",
        "Uccello",
        "Autunno",
        "Orecchio",
        "Lanterna",
        "Stone",
        "Balena",
        "Dadi",
        "Ragazza",
        "Coniglio",
        "Parlare",
        "Ape",
        "Piazza",
        "Pepe",
        "Mare",
        "Renna",
        "Libro",
        "Pellicano",
        "Bella",
        "Slip",
        "Sei",
        "Spada",
        "Uova",
        "Pentola",
        "Acqua",
        "Finestra",
        "Giocare",
        "Pinguino",
        "Soldi",
        "Piedi",
        "Perno",
        "Naso",
        "Frutta",
        "Fischio",
        "Cane",
        "Borsa",
        "Zucca",
        "Pettine",
        "Male",
        "Sporco",
        "Codini",
        "Porta",
        "Albero",
        "Pollo",
        "Matita",
        "Latte",
        "Palma",
        "Vestito",
        "Figlia",
        "Patata",
        "Piccolo",
        "Tulipano",
        "Nuovo",
        "Lattina",
        "Asciugamano",
        "Gelato",
        "Rosa",
        "Lavello",
        "Tovagliolo",
        "Plaza",
        "Vernice",
        "Spiaggia",
        "Pulito",
        "Cipolla",
        "Braccio",
        "Volante",
        "Sopracciglia",
        "Maccheroni",
        "Pacificatore",
        "Drum",
        "Carne",
        "Vite",
        "Ferro",
        "Altalena",
        "Panda",
        "Fantasma",
        "Pannolino",
        "Serpente",
        "Pera",
        "Orso",
        "Barba",
        "Taxi",
        "Scala",
        "Arcobaleno",
        "Statua",
        "Cucchiaio",
        "Orologio",
        "Sandwich",
        "Lumaca",
        "Sol",
        "Cuore",
        "Sette",
        "Estate",
        "Foglio",
        "Padre",
        "Strappo",
        "Pomodori",
        "Nonna",
        "Cerchio",
        "Inverno",
        "Due",
        "Ridere",
        "Dieci",
        "Fragola",
        "Brutto",
        "Elicottero",
        "Burger",
        "Film",
        "Cubo",
        "Avvio",
        "Lavagna",
        "Bere",
        "Camicia",
        "Dito",
        "Astronauta",
        "Cracker",
        "Spalla",
        "Dormire",
        "Palloncino",
        "Forbici",
        "Arancione",
        "Triangolo",
        "Giallo",
        "Aereo",
        "Lampada",
        "Volare",
        "Pittore",
        "Otto",
        "Nonno",
        "Bianco",
        "Treno",
        "Scarpa",
        "Berretto",
        "Tovaglia",
        "Coccinella",
        "Bambino",
        "Nove",
        "Computer",
        "Tre",
        "Tavola",
        "Polso",
        "Tappeto",
        "Valigia",
        "Sopra",
        "Spina",
        "Casa",
        "Luce",
        "Bene",
        "Insegnante",
        "Venditore",
        "Pala",
        "Coltello",
        "Falegname",
        "Castello",
        "Tromba",
        "Caldo",
        "Anello",
        "Ombrello",
        "Salto",
        "Raggio",
        "Occhiali",
        "Pulcino",
        "Cinque",
        "Calcio",
        "Ragno",
        "Correre",
        "Scimmia",
        "Carrozza",
        "Occhio",
        "Pesca",
        "Oliva",
        "Mourn",
        "Limone",
        "Verde",
        "Fratello",
        "Mucca",
        "Fonte",
        "Neve",
        "Negozio",
        "Cuoco",
        "Capelli",
        "Cabina",
        "Malato",
        "Foca",
        "Nero",
        "Zaino",
        "Cappello",
        "Vasca",
        "Topo",
        "Rosso",
        "Muro",
        "Lento",
        "Faccia",
        "Gabbiano",
        "Vento",
        "Cestino",
        "Torta",
        "Piatto",
        "Gesso",
        "Vaso",
        "Uovo",
        "Gomma",
        "Noè",
        "Caffè",
        "Pomata",
        "Riposo",
        "Zebra",
        "Buono",
        "Aliante",
        "Africano",
        "Tutù",
        "Casalinga",
        "Partenza",
        "Capitano",
        "Bottiglia",
        "Sole",
        "Pedali",
        "Martello",
        "Ladro",
        "Olimpo",
        "Stretto",
        "Scrivania",
        "Re",
        "Cognome",
        "Acciuga",
        "Virgola",
        "Colla",
        "Peloso",
        "Nubile",
        "Giardiniere",
        "Spartito",
        "Palio",
        "Marinaio",
        "Conto",
        "Previsioni",
        "Anatroccolo",
        "Metà",
        "Siena",
        "Dicembre",
        "Gilet",
        "Brontolo",
        "Aria",
        "Gioconda",
        "Ascensore",
        "Candela",
        "Sorpasso",
        "Anteriore",
        "Cappuccio",
        "Sale",
        "Margherita ",
        "Cinquina",
        "Liana",
        "Corallo",
        "Picasso",
        "Maturo",
        "Sinonimo",
        "Bermuda",
        "Dopodomani",
        "Sbadiglio",
        "Madrid",
        "Attore",
        "Occhiolino",
        "Orizzontale",
        "Abracadabra",
        "Bolle",
        "Staffetta",
        "Olfatto",
        "Prezzo",
        "Riso",
        "Rotella",
        "Isola",
        "Festival",
        "Più",
        "Dentro",
        "Calamita",
        "Gennaio",
        "Cappelli",
        "Proboscide ",
        "Saloon",
        "Renzo",
        "Vegetariano",
        "Bilancia",
        "Federa",
        "Lotteria",
        "Paparazzo",
        "Ciak",
        "Biscotti",
        "Verona",
        "Miele",
        "Stiva",
        "Fresco",
        "Aceto",
        "Capanna",
        "Poltrona",
        "Note ",
        "Crociera",
        "Falso",
        "Erba",
        "Pacifico",
        "Odio",
        "Velo ",
        "ketchup ",
        "Ozono",
        "Gondola ",
        "Giardino",
        "Coccinella ",
        "Tempura",
        "Chiuso ",
        "Racchetta",
        "Ciambella",
        "Euro",
        "Calciatore",
        "Oroscopo",
        "Pioggia",
        "Molari",
        "Sera",
        "Comune",
        "Scritto",
        "Focaccia",
        "Incisivi",
        "Tarzan",
        "Zucchina",
        "Fumo",
        "Scoglio",
        "Regali",
        "Cupido",
        "Regista",
        "Tartufo",
        "Spugna",
        "Hockey",
        "Pila",
        "Specchietto",
        "Lacrime",
        "Note",
        "Ago",
        "Prosciutto ",
        "Africa",
        "Tombola",
        "Esame",
        "Insonnia",
        "Semaforo",
        "Gemelli",
        "Pipa",
        "Lancette",
        "Stringhe",
        "Letto",
        "Sinistra",
        "Campane",
        "Tacchi",
        "Solletico",
        "Pennello",
        "Contorno",
        "Copenaghen ",
        "Albume",
        "Pagliaio",
        "Crostata ",
        "Orale",
        "Montalbano",
        "Timone",
        "Tubetto",
        "Affettatrice",
        "Oggi",
        "Tramezzino",
        "Torino",
        "Derby",
        "Imbuto",
        "Beatrice",
        "Pesante",
        "Equatore",
        "Alveare",
        "Indirizzo",
        "Fiatone",
        "Fiore",
        "Asinello",
        "Nuora",
        "Ercole",
        "Cinema",
        "Pomeriggio",
        "Semplice",
        "Salsiccia",
        "Lucia",
        "Sampdoria",
        "Robot",
        "Peperoncino",
        "Leone",
        "Atletica",
        "Mensa",
        "Uscita",
        "Bora",
        "Secolo",
        "Roulette",
        "Colletto",
        "Biancaneve",
        "Zoccoli",
        "Zia",
        "Camino",
        "Criceto",
        "Feriale",
        "Notizie",
        "Sardegna",
        "Leggero",
        "Gobbe",
        "Forno",
        "Pitagora ",
        "Piselli",
        "Abete",
        "Galateo",
        "Madrina",
        "Ruvido",
        "Gioielliere",
        "Camera",
        "Rami",
        "Chilo",
        "Iceberg ",
        "Larghezza",
        "Spine",
        "Lati",
        "Bugia",
        "Cactus",
        "Satellite",
        "Rastrello",
        "Ulisse",
        "Gargano",
        "Pareo",
        "Nipote",
        "Caramelle",
        "Portinaia",
        "Lampadario",
        "Ali",
        "Infinito",
        "Scuro",
        "Insipido",
        "Piastrelle",
        "Pacco",
        "Retino",
        "Pisa",
        "Tutto",
        "Motore",
        "Parenti",
        "Tendone",
        "Ciabatte",
        "Baffi",
        "Storto",
        "Lenticchie ",
        "Sindaco",
        "Quarto",
        "Pagella",
        "Giulietta",
        "Balsamo",
        "Muscoli",
        "Nilo",
        "Fabbro",
        "Arancino",
        "Catena",
        "Lunedì",
        "vendemmia",
        "Gallina",
        "Senape",
        "Gargamella",
        "Pozzo",
        "Sabbia",
        "Nudo",
        "Sempre",
        "Cannolo",
        "Mancia",
        "Totò",
        "Latitudine",
        "Aperitivo",
        "Cicala",
        "Cubetto",
        "Apollo",
        "Asola",
        "Divano",
        "Alpi",
        "Articoli",
        "Gibilterra",
        "Menta",
        "Letargo",
        "Maratona",
        "Aprire",
        "Notte",
        "Mezzanotte",
        "Colosseo"
    ],
    double: [
        "Ora legale",
        "Ora solare",
        "Emma Marrone",
        "Marco Polo",
        "Accademia della Crusca",
        "Acido desossiribonucleico",
        "Acqua e sapone",
        "Agente segreto",
        "Albero di Natale",
        "Anidride carbonica",
        "Anno bisestile",
        "Anno Nuovo",
        "Arco di Trionfo",
        "Babbo Natale",
        "Battaglia di Waterloo",
        "Big Ben",
        "Bosone di Higgs",
        "Buco dell'ozono",
        "Buon Compleanno",
        "Camera dei Deputati",
        "Campo da calcio",
        "Cane da guardia",
        "Canto delle sirene",
        "Capo di Stato",
        "Carta d'identità",
        "Carta di credito",
        "Casa Bianca",
        "Cavallo di Troia",
        "Codice a barre",
        "Codice fiscale",
        "Congiuntivo imperfetto",
        "Corte Costituzionale",
        "Corte d'Appello",
        "Dichiarazione dei redditi",
        "Divina Commedia",
        "Effetto farfalla",
        "Effetto serra",
        "Energia solare",
        "Esame di maturità",
        "Ferro da stiro",
        "Film d'animazione",
        "Fontana di Trevi",
        "Forno a microonde",
        "Giudice di pace",
        "Giuramento di Ippocrate",
        "Grande Muraglia",
        "Guardia di Finanza",
        "Guerra Fredda",
        "Harry Potter",
        "Inno di Mameli",
        "Intelligenza artificiale",
        "Isole Canarie",
        "James Bond",
        "Legge di Murphy",
        "Leonardo da Vinci",
        "Libero arbitrio",
        "Macchina fotografica",
        "Mercato del lavoro",
        "Moto perpetuo",
        "Muro di Berlino",
        "Nazioni Unite",
        "Numero di Avogadro",
        "Parco nazionale",
        "Patente di guida",
        "Patto Atlantico",
        "Alessandro Magno",
        "Pesce d'aprile",
        "Pi greco",
        "Piano cartesiano",
        "Piazza San Pietro",
        "Pietra filosofale",
        "Ponte dei Sospiri",
        "Primo Maggio",
        "Principio di indeterminazione",
        "Prodotto interno lordo",
        "Pronto Soccorso",
        "Rasoio di Occam",
        "Re Sole",
        "Repubblica Italiana",
        "Rivoluzione Francese",
        "Sacro Romano Impero",
        "Sbarco in Normandia",
        "Seconda Guerra Mondiale",
        "Sistema solare",
        "Spada nella roccia",
        "Stazione Centrale",
        "Statua della Libertà",
        "Stella Polare",
        "Tallone d'Achille",
        "Tanti Auguri",
        "Teorema di Pitagora",
        "Torre di Pisa",
        "Trattato di Maastricht",
        "Unione Europea",
        "Uovo di Colombo",
        "Vaso di Pandora",
        "Via Lattea",
        "Vigili del Fuoco"
    ]
};